export default "__VITE_ASSET__88b27c14__"